import React from 'react';

import PropTypes from 'prop-types';
import { Button, Spinner } from 'react-bootstrap';

// Shared "Cancel" button for the Brand SKU Mapper review views' run indicator.
export default function CancelRunButton({ cancelling, onClick }) {
  return (
    <Button
      size="sm"
      variant="outline-danger"
      className="ml-2"
      disabled={cancelling}
      onClick={onClick}
    >
      {cancelling ? <Spinner animation="border" size="sm" /> : 'Cancel'}
    </Button>
  );
}

CancelRunButton.propTypes = {
  cancelling: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
